import flagenglish from '../../../assets/images/flags/gb.svg'
import flaggermany from '../../../assets/images/flags/germany.svg'
import flagcroatian from '../../../assets/images/flags/hr.svg'
import flagslovenian from '../../../assets/images/flags/sl.svg'
import flagitalien from '../../../assets/images/flags/it.svg'

// add more flags if needed
const flags: Record<string, { flag: string }> = {
    hr: {
        flag: flagcroatian,
    },
    en: {
        flag: flagenglish,
    },
    de: {
        flag: flaggermany,
    },
    it: {
        flag: flagitalien,
    },
    sl: {
        flag: flagslovenian,
    },
}

export default flags
